import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Page = ({ children }) => (
  <motion.main
    initial={{ opacity: 0, y: 14 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -10 }}
    transition={{ duration: 0.4, ease: EASE }}
  >
    {children}
  </motion.main>
);

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block will-change-transform"
      initial={{ y: "112%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const SectionTag = ({ children, className = "" }) => (
  <div
    className={`mb-6 flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] text-cad/90 ${className}`}
  >
    <span className="h-px w-8 bg-cad/60" />
    {children}
  </div>
);
